import { goal } from './reducers';
export default goal;
